import React from 'react'
import { IonPage } from '@ionic/react'
import { useHistory } from 'react-router';

import Toolbar from '../components/Toolbar';
import ListSinals from '../components/ListSinais';
import { DETAILS_SIGNAL_ROUTER } from '../Routers';
import { Sinal } from '../models/Sinal';

export interface Props {
    selectMode?: boolean
    onSelect: (item: Sinal) => any
}

const Signals: React.FC<Props> = () => {
  const history = useHistory()

  function onSelect(sinal: Sinal) {
    history.push(`${DETAILS_SIGNAL_ROUTER}?sinalId=${sinal.id}`)
  }

  return (
    <IonPage>
      <Toolbar infoBtn={false} menuBtn={true} title="Sinais" />
      <ListSinals selectMode={true} onSelect={onSelect} />
    </IonPage >
  )
}

export default Signals
